export default __webpack_public_path__ + "static/media/tempStore3.a7b7968c.png";